import styles from "./styles/ReportsHeader.module.scss";

export default function NotificationsHeader() {
  return (
    <>
      <span className={styles.header}>اطلاعیه ها</span>
    </>
  );
}
